export default __webpack_public_path__ + "static/media/morjor.43847f4d.jpg";